import React from 'react';

const addLineBreaks = (string) =>
  string.split('\n').map((text, index) => (
    <React.Fragment key={`${text}-${index}`}>
      {text}
      <br />
    </React.Fragment>
  ));

const BriefIcon = ({summary, titleIcon, title, paragraph, textColor}) => (
  <div className="wrap" style={{color:textColor}}>
     <div className="col col-1">
       <h5 className="summary" style={{color:textColor}}>{summary}</h5>
     </div>
     {title !== undefined
       ?      <div className="col col-1 col-1-2--m">
               <h2 className="slogan remove-margin-top" style={{color:textColor}}>{titleIcon}{addLineBreaks(title)}</h2>
             </div>
      : null
     }

      <div className="col col-1 col-1-2--m">
        <p className="text-soft">{addLineBreaks(paragraph)}</p>
      </div>
  </div>
);
export default BriefIcon;

//Brief 아이콘 말고 이너 브리프라던지 다른 이름응로 불러보자.



// WEBPACK FOOTER //
// ./src/layout/hero/BriefIcon.js